import { useEffect, useState } from 'react';

export default function HomePage() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    document.title = 'Esaul Lorenzo';
    setIsLoaded(true);

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Domina el tráfico pago y conoce las estrategias para vender productos digitales en automático'
      );
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute(
        'content',
        'tráfico pago, estrategia digital, productos digitales, embudo rentable, monetización'
      );
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#0a1a2e] flex flex-col items-center overflow-hidden relative">

      {/* Hero Section */}
      <section className="w-full relative z-10">
        <div className="w-full max-w-2xl mx-auto px-0 sm:px-5 pt-0 sm:pt-16 pb-4 sm:pb-12 relative">
          <div className="relative">
            {/* Profile Image with Overlay Content */}
            <div className="flex justify-center">
              <div className="w-full sm:max-w-lg relative">
                {/* Image Container */}
                <div className="relative">
                  {/* Degradado superior para fusión completa en móvil */}
                  <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-[#0a1a2e] via-[#0a1a2e]/60 to-transparent z-10 sm:hidden"></div>

                  {/* Degradados laterales para fusión en móvil */}
                  <div className="absolute top-0 bottom-0 left-0 w-16 bg-gradient-to-r from-[#0a1a2e] via-[#0a1a2e]/40 to-transparent z-10 sm:hidden"></div>
                  <div className="absolute top-0 bottom-0 right-0 w-16 bg-gradient-to-l from-[#0a1a2e] via-[#0a1a2e]/40 to-transparent z-10 sm:hidden"></div>

                  <img
                    src="https://static.readdy.ai/image/3e793795e87845ada69b8088167d8f30/bb45619cc5c92609e1679f921e7e2d63.jpeg"
                    alt="Esaul Lorenzo - Experto en tráfico pago y productos digitales"
                    className="w-full h-[65vh] sm:h-auto sm:rounded-2xl object-cover object-top shadow-none sm:shadow-2xl"
                    loading="eager"
                    decoding="async"
                    fetchPriority="high"
                  />

                  {/* Degradado inferior más extenso para fusión perfecta en móvil */}
                  <div className="sm:hidden absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-t from-[#0a1a2e] via-[#0a1a2e]/95 to-transparent"></div>

                  {/* Gradient Overlay - Only visible on desktop */}
                  <div className="hidden sm:block absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent rounded-2xl"></div>

                  {/* Content Overlay - Only visible on desktop */}
                  <div className="hidden sm:block absolute bottom-0 left-0 right-0 p-8 text-center">
                    <h1 className="text-white text-5xl font-bold mb-3 drop-shadow-lg">
                      ESAUL LORENZO
                    </h1>
                    <p className="text-gray-100 text-lg font-normal mb-6 drop-shadow-md">
                      Convierte desconocidos en clientes.
                      Domina el arte de vender en automático.
                    </p>

                    {/* Social Links */}
                    <div className="flex items-center justify-center gap-6">
                      <a
                        href="https://www.instagram.com/esaullorenzo/"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        className="text-white hover:text-[#F4D03F] transition-colors cursor-pointer drop-shadow-lg"
                        aria-label="Instagram"
                      >
                        <i className="ri-instagram-line text-3xl"></i>
                      </a>
                      <a
                        href="https://www.youtube.com/@ESAULLORENZO"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        className="text-white hover:text-[#F4D03F] transition-colors cursor-pointer drop-shadow-lg"
                        aria-label="YouTube"
                      >
                        <i className="ri-youtube-line text-3xl"></i>
                      </a>
                      <a
                        href="https://www.tiktok.com/@esaullorenzo.a"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        className="text-white hover:text-[#F4D03F] transition-colors cursor-pointer drop-shadow-lg"
                        aria-label="TikTok"
                      >
                        <i className="ri-tiktok-line text-3xl"></i>
                      </a>
                    </div>
                  </div>
                </div>

                {/* Content Below Image - Only visible on mobile */}
                <div className="sm:hidden text-center -mt-32 relative z-20 px-6">
                  <h1 className="text-white text-3xl font-bold mb-3 drop-shadow-lg">
                    ESAUL LORENZO
                  </h1>
                  <p className="text-gray-200 text-base font-normal mb-6 px-2 leading-relaxed drop-shadow-md">
                    Convierte desconocidos en clientes.
                    Domina el arte de vender en automático.
                  </p>

                  {/* Social Links */}
                  <div className="flex items-center justify-center gap-6">
                    <a
                      href="https://www.instagram.com/esaullorenzo/"
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="text-white hover:text-[#F4D03F] transition-all duration-300 cursor-pointer hover:scale-110"
                      aria-label="Instagram"
                    >
                      <i className="ri-instagram-line text-2xl"></i>
                    </a>
                    <a
                      href="https://www.youtube.com/@ESAULLORENZO"
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="text-white hover:text-[#F4D03F] transition-all duration-300 cursor-pointer hover:scale-110"
                      aria-label="YouTube"
                    >
                      <i className="ri-youtube-line text-2xl"></i>
                    </a>
                    <a
                      href="https://www.tiktok.com/@esaullorenzo.a"
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="text-white hover:text-[#F4D03F] transition-all duration-300 cursor-pointer hover:scale-110"
                      aria-label="TikTok"
                    >
                      <i className="ri-tiktok-line text-2xl"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cards Section */}
      <section className="w-full max-w-2xl mx-auto px-4 sm:px-5 pb-12 sm:pb-16 space-y-4 sm:space-y-5 relative z-20">
        {/* Card 1: ACADEMIA TRÁFICO PRO ELITE */}
        <div
          className={`
            bg-white/[0.06] sm:bg-[#0a1628]/80 
            backdrop-blur-xl
            border border-white/10 sm:border-[#1a3050]/50 
            rounded-2xl sm:rounded-lg 
            p-4 sm:p-6
            transition-all duration-500 will-change-[transform,opacity]
            shadow-lg shadow-black/20
            ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}
          `}
          style={{ transitionDelay: '100ms' }}
        >
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-[#F4D03F] to-[#F5AB35] rounded-xl flex items-center justify-center shadow-lg shadow-[#F4D03F]/20">
                <i className="ri-graduation-cap-line text-xl sm:text-2xl text-[#0A1E3D]"></i>
              </div>
            </div>
            <div className="flex-1">
              <h2 className="text-[#F4D03F] text-xl sm:text-2xl font-semibold mb-2">
                🚀 ACADEMIA TRÁFICO PRO ÉLITE&nbsp;
              </h2>
              <p className="text-gray-200/90 sm:text-gray-200 text-sm sm:text-base font-medium leading-relaxed">
                🔥 Todo lo que necesitas para facturar.✅ Estrategias probadas para Productos Digitales.
                ✅ Dominio total de Facebook Ads y Contingencias.
                ✅ Automatización de ventas con IA (ChatGPT + n8n etc )⏳ INSCRIPCIONES ABIERTAS POR TIEMPO LIMITADO.
              </p>
            </div>
          </div>
          <a
            href="https://www.skool.com/trafico-pro-elite-vip-9343/about"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="group block w-full bg-gradient-to-r from-[#FF6B35] to-[#FF5722] hover:from-[#FF5722] hover:to-[#E64A19] text-white font-semibold text-sm sm:text-base py-3.5 px-6 rounded-xl transition-all duration-300 text-center whitespace-nowrap cursor-pointer shadow-lg shadow-[#FF6B35]/30 hover:shadow-[#FF6B35]/50 hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2 animate-float-up"
          >
            <span>$15/mes — Unirme ahora</span>
            <i className="ri-rocket-2-line text-lg transition-transform duration-300 group-hover:translate-x-1"></i>
          </a>
        </div>

        {/* Card 2: COMUNIDAD EN WHATSAPP */}
        <div
          className={`
            bg-white/[0.06] sm:bg-[#0a1628]/80 
            backdrop-blur-xl
            border border-white/10 sm:border-[#1a3050]/50 
            rounded-2xl sm:rounded-lg 
            p-4 sm:p-6
            transition-all duration-500 will-change-[transform,opacity]
            shadow-lg shadow-black/20
            ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}
          `}
          style={{ transitionDelay: '200ms' }}
        >
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-[#25D366] to-[#128C7E] rounded-xl flex items-center justify-center shadow-lg shadow-[#25D366]/20">
                <i className="ri-whatsapp-line text-xl sm:text-2xl text-white"></i>
              </div>
            </div>
            <div className="flex-1">
              <h2 className="text-[#F4D03F] text-xl sm:text-2xl font-semibold mb-2">
                🎁 ACCESO VIP: HERRAMIENTAS Y GUÍAS GRATIS
              </h2>
              <p className="text-gray-200/90 sm:text-gray-200 text-sm sm:text-base font-medium leading-relaxed">
                🎁 Accede a Herramientas + Tutoriales GRATIS( Únete a la Comunidad VIP. Aprende a Vender con IA, Ads y Automatización hoy mismo.)
              </p>
            </div>
          </div>
          <a
            href="https://chat.whatsapp.com/D1ddDVG4KWTK9K7vPP9RsZ?mode=gi_t"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="group block w-full bg-gradient-to-r from-[#25D366] to-[#128C7E] hover:from-[#128C7E] hover:to-[#075E54] text-white font-semibold text-sm sm:text-base py-3.5 px-6 rounded-xl transition-all duration-300 text-center whitespace-nowrap cursor-pointer shadow-lg shadow-[#25D366]/30 hover:shadow-[#25D366]/50 hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2 animate-glow"
          >
            <span>Ingresar ahora</span>
            <i className="ri-whatsapp-line text-lg transition-transform duration-300 group-hover:translate-x-1"></i>
          </a>
        </div>

        {/* Card 3: MENTORÍA 1 A 1 */}
        <div
          className={`
            bg-white/[0.06] sm:bg-[#0a1628]/80 
            backdrop-blur-xl
            border border-white/10 sm:border-[#1a3050]/50 
            rounded-2xl sm:rounded-lg 
            p-4 sm:p-6
            transition-all duration-500 will-change-[transform,opacity]
            shadow-lg shadow-black/20
            ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}
          `}
          style={{ transitionDelay: '300ms' }}
        >
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-[#F4D03F] to-[#F5AB35] rounded-xl flex items-center justify-center shadow-lg shadow-[#F4D03F]/20">
                <i className="ri-user-star-line text-xl sm:text-2xl text-[#0A1E3D]"></i>
              </div>
            </div>
            <div className="flex-1">
              <h2 className="text-[#F4D03F] text-xl sm:text-2xl font-semibold mb-2">
                🚀 MENTORÍA PRIVADA 1 A 1 (SOLICITAR CUPO)
              </h2>
              <p className="text-gray-200/90 sm:text-gray-200 text-sm sm:text-base font-medium leading-relaxed">
                Trabajamos 1 a 1 en lo que tu negocio necesita HOY: Contingencias Antibloqueos, Automatización con n8n, Flujos de WhatsApp o Estrategia de Ventas. Destrabamos tu cuello de botella técnico o estratégico para que factures sin límites.
              </p>
            </div>
          </div>
          <a
            href="https://wa.link/rbgv9e"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="group block w-full bg-gradient-to-r from-[#FF6B35] to-[#FF5722] hover:from-[#FF5722] hover:to-[#E64A19] text-white font-semibold text-sm sm:text-base py-3.5 px-6 rounded-xl transition-all duration-300 text-center whitespace-nowrap cursor-pointer shadow-lg shadow-[#FF6B35]/30 hover:shadow-[#FF6B35]/50 hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2 animate-breathe"
          >
            <span>Ver cupos disponibles</span>
            <i className="ri-calendar-check-line text-lg transition-transform duration-300 group-hover:translate-x-1"></i>
          </a>
        </div>

        {/* Card 4: CANAL DE YOUTUBE */}
        <div
          className={`
            bg-white/[0.06] sm:bg-[#0a1628]/80 
            backdrop-blur-xl
            border border-white/10 sm:border-[#1a3050]/50 
            rounded-2xl sm:rounded-lg 
            p-4 sm:p-6
            transition-all duration-500 will-change-[transform,opacity]
            shadow-lg shadow-black/20
            ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}
          `}
          style={{ transitionDelay: '400ms' }}
        >
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-[#F4D03F] to-[#F5AB35] rounded-xl flex items-center justify-center shadow-lg shadow-[#F4D03F]/20">
                <i className="ri-youtube-line text-xl sm:text-2xl text-[#0A1E3D]"></i>
              </div>
            </div>
            <div className="flex-1">
              <h2 className="text-[#F4D03F] text-xl sm:text-2xl font-semibold mb-2">
                🔴 VER CLASES GRATIS EN YOUTUBE
              </h2>
              <p className="text-gray-200/90 sm:text-gray-200 text-sm sm:text-base font-medium leading-relaxed">
                Contenido gratuito cada semana sobre tráfico pago, embudos de venta, automatización con IA y estrategias para escalar tu negocio digital. ¡Suscríbete y activa la campanita!
              </p>
            </div>
          </div>
          <a
            href="https://www.youtube.com/@ESAULLORENZO"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="group block w-full bg-gradient-to-r from-[#FF6B35] to-[#FF5722] hover:from-[#FF5722] hover:to-[#E64A19] text-white font-semibold text-sm sm:text-base py-3.5 px-6 rounded-xl transition-all duration-300 text-center whitespace-nowrap cursor-pointer shadow-lg shadow-[#FF6B35]/30 hover:shadow-[#FF6B35]/50 hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2 animate-sway"
          >
            <span>Acceder al canal de YouTube</span>
            <i className="ri-play-circle-line text-lg transition-transform duration-300 group-hover:translate-x-1"></i>
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full py-6 px-4 text-center text-gray-400 text-xs sm:text-sm relative z-10">
        <p>
          © {new Date().getFullYear()} Esaul Lorenzo. Todos los derechos reservados.
        </p>
        <a
          href="https://readdy.ai/?ref=logo"
          rel="nofollow"
          className="text-gray-500 hover:text-gray-300 transition-colors text-xs mt-2 inline-block cursor-pointer"
        >
          Powered by Readdy
        </a>
      </footer>
    </div>
  );
}
